module.exports = __webpack_public_path__ + "img/btn_google_play@2x.97069c2.png";